"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCallforward = void 0;
const react_1 = require("react");
function useCallforward(callback, deps) {
    const callbacks = (0, react_1.useRef)(new Map());
    // The following bit is a bit like useEffect() in that
    // if the deps have changed then do a thing
    // However, useEffect doesn't fire early enough in the flow, so
    // we handle dep checking ourselves
    const lastDeps = (0, react_1.useRef)(deps);
    if (deps.some((d, i) => d !== lastDeps.current[i])) {
        callbacks.current = new Map();
        lastDeps.current = deps;
    }
    // Ok ... this is a bit complicated ... basically this function wants to
    // try and return the same result of the callback everytime it is called
    // with the same args
    // The way it does this is to create a tree of args who's leaf is the callback
    // If a leaf exists, it returns that, otherwise it creates it and then returns it
    return (0, react_1.useCallback)((...args) => {
        let map = callbacks.current;
        for (let i = 1; i <= args.length; i++) {
            const arg = args[i - 1];
            // The are further args in the list
            if (i < args.length) {
                if (!map.has(arg))
                    map.set(arg, new Map());
                map = map.get(arg);
            }
            // This is a leaf arg
            else {
                if (!map.has(arg))
                    map.set(arg, callback(...args));
                return map.get(arg);
            }
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    deps);
}
exports.useCallforward = useCallforward;
exports.default = useCallforward;
